<div class="backdrop" [class.open]="isOpen()" (click)="closed.emit()"></div>

<div class="schedule-panel" [class.open]="isOpen()">
  <div class="panel-header">
    <h2 class="panel-title">Live Lessons Schedule</h2>
    <button type="button" class="close-btn" (click)="closed.emit()" aria-label="Close">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="panel-controls">
    <app-search-bar
      [data]="lessons()"
      [searchKeys]="searchKeys"
      placeholder="Search"
      (filtered)="filteredLessons.set($event)"
    ></app-search-bar>

    <div class="filter-row">
      <div class="filter-dropdown" #filterDropdown>
        <button
          type="button"
          class="filter-btn"
          [class.active]="selectedTagIds().size > 0"
          (click)="toggleFilterPanel()"
        >
          <span class="material-symbols-outlined">filter_list</span>
          Filter
          @if (selectedTagIds().size > 0) {
            <span class="filter-badge">{{ selectedTagIds().size }}</span>
          }
        </button>

        @if (filterOpen()) {
          <div class="filter-panel">
            @for (tag of tags(); track tag.id) {
              <button
                type="button"
                class="filter-option"
                [class.active]="selectedTagIds().has(tag.id)"
                (click)="toggleTag(tag.id)"
              >
                <span class="option-checkbox">
                  @if (selectedTagIds().has(tag.id)) {
                    <span class="material-symbols-outlined">check</span>
                  }
                </span>
                {{ tag.display_title }}
              </button>
            }
            @if (selectedTagIds().size > 0) {
              <button type="button" class="clear-btn" (click)="clearTags()">
                Clear all
              </button>
            }
          </div>
        }
      </div>

      @if (selectedTags().length) {
        <div class="selected-tags">
          @for (tag of selectedTags(); track tag.id) {
            <span class="selected-tag-chip">
              {{ tag.display_title }}
              <button
                type="button"
                class="remove-tag-btn"
                (click)="toggleTag(tag.id)"
                [attr.aria-label]="'Remove ' + tag.display_title + ' filter'"
              >
                <span class="material-symbols-outlined">close</span>
              </button>
            </span>
          }
        </div>
      }
    </div>
  </div>

  <div class="panel-body">
    @if (displayedLessons().length === 0) {
      <p class="empty-state">No upcoming lessons found.</p>
    } @else {
      @for (lesson of displayedLessons(); track lesson.id) {
        <app-live-lesson-schedule-item [lesson]="lesson"></app-live-lesson-schedule-item>
      }
    }
  </div>
</div>
